import { createContext, useContext, useMemo, useState } from "react";
import { dict } from "@/lib/translations";

export const LANGS = [
  { code: "en", label: "English" },
  { code: "ms", label: "Bahasa Melayu" },
  { code: "zh", label: "中文" },
  { code: "id", label: "Bahasa Indonesia" },
  { code: "th", label: "ไทย" },
  { code: "vi", label: "Tiếng Việt" },
];

const KEY = "qrf_lang";

export const detectLang = () => {
  const saved = localStorage.getItem(KEY);
  if (saved && dict[saved]) return saved;
  const prefs = navigator.languages?.length ? navigator.languages : [navigator.language || "en"];
  for (const p of prefs) {
    const base = (p || "").toLowerCase().split("-")[0];
    if (base === "in") return "id";
    if (base === "zsm") return "ms";
    if (dict[base]) return base;
  }
  return "en";
};

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(detectLang);

  const value = useMemo(() => {
    const setLang = (l) => {
      localStorage.setItem(KEY, l);
      setLangState(l);
    };
    const t = (key, vars = {}) => {
      const s = dict[lang]?.[key] ?? dict.en[key] ?? key;
      return s.replace(/\{(\w+)\}/g, (_, k) => (vars[k] ?? ""));
    };
    return { lang, setLang, t };
  }, [lang]);

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useT = () => useContext(LangContext);
